// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1163":"6005452c","3500":"4746385e","4696":"4b95b3e3"}[chunkId] + ".chunk.css";
};